/** Short names for binding codes, as the HUD and the Controls screen print them. Pure. */

const NAMED: Readonly<Record<string, string>> = {
  Mouse0: 'LMB',
  Mouse1: 'MMB',
  Mouse2: 'RMB',
  Mouse3: 'MB4',
  Mouse4: 'MB5',
  WheelUp: 'WHEEL UP',
  WheelDown: 'WHEEL DN',
  ArrowUp: 'UP',
  ArrowDown: 'DOWN',
  ArrowLeft: 'LEFT',
  ArrowRight: 'RIGHT',
  ShiftLeft: 'SHIFT',
  ShiftRight: 'R SHIFT',
  ControlLeft: 'CTRL',
  ControlRight: 'R CTRL',
  AltLeft: 'ALT',
  AltRight: 'R ALT',
  Escape: 'ESC',
  Space: 'SPACE',
  Enter: 'ENTER',
  Tab: 'TAB',
  Backspace: 'BKSP',
  Delete: 'DEL',
  Insert: 'INS',
  Home: 'HOME',
  End: 'END',
  PageUp: 'PG UP',
  PageDown: 'PG DN',
  CapsLock: 'CAPS',
  Backquote: '`',
  Minus: '-',
  Equal: '=',
  BracketLeft: '[',
  BracketRight: ']',
  Backslash: '\\',
  Semicolon: ';',
  Quote: "'",
  Comma: ',',
  Period: '.',
  Slash: '/',
};

/** `KeyW` -> `W`, `Digit1` -> `1`, `Mouse0` -> `LMB`, `ShiftLeft` -> `SHIFT`; unknown codes in capitals. */
export function keyLabel(code: string): string {
  const named = NAMED[code];
  if (named !== undefined) return named;
  if (/^Key[A-Z]$/.test(code)) return code.slice(3);
  if (/^Digit[0-9]$/.test(code)) return code.slice(5);
  if (/^Numpad/.test(code)) return `NUM ${code.slice(6).toUpperCase()}`;
  return code.toUpperCase();
}

/** `W / UP`, or a dash for an action with nothing bound. */
export function keysLabel(codes: readonly string[]): string {
  return codes.length === 0 ? '-' : codes.map(keyLabel).join(' / ');
}
